export default __webpack_public_path__ + "static/media/1989.b5d0442b.png";